module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "box"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('va-alert', [_c('h4', {
    slot: "header"
  }, [_c('i', {
    staticClass: "icon fa fa-check"
  }), _vm._v(" CoPilot is open source!\n        ")]), _vm._v(" "), _c('div', {
    slot: "body"
  }, [_vm._v("\n          Click on icon to check out it out on github.\n          "), _c('a', {
    attrs: {
      "href": "https://github.com/misterGF/CoPilot",
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "fa fa-github fa-2x"
  })])])]), _vm._v(" "), _c('va-alert', {
    attrs: {
      "type": "success"
    }
  }, [_c('h4', {
    slot: "header"
  }, [_c('i', {
    staticClass: "icon fa fa-check"
  }), _vm._v(" CoPilot is open source!\n        ")]), _vm._v(" "), _c('div', {
    slot: "body"
  }, [_vm._v("\n          Click on icon to check out it out on github.\n          "), _c('a', {
    attrs: {
      "href": "https://github.com/misterGF/CoPilot",
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "fa fa-github fa-2x"
  })])])]), _vm._v(" "), _c('va-alert', {
    attrs: {
      "type": "info"
    }
  }, [_c('h4', {
    slot: "header"
  }, [_c('i', {
    staticClass: "icon fa fa-check"
  }), _vm._v(" CoPilot is open source!\n        ")]), _vm._v(" "), _c('div', {
    slot: "body"
  }, [_vm._v("\n          Click on icon to check out it out on github.\n          "), _c('a', {
    attrs: {
      "href": "https://github.com/misterGF/CoPilot",
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "fa fa-github fa-2x"
  })])])]), _vm._v(" "), _c('va-alert', {
    attrs: {
      "type": "warning"
    }
  }, [_c('h4', {
    slot: "header"
  }, [_c('i', {
    staticClass: "icon fa fa-check"
  }), _vm._v(" CoPilot is open source!\n        ")]), _vm._v(" "), _c('div', {
    slot: "body"
  }, [_vm._v("\n          Click on icon to check out it out on github.\n          "), _c('a', {
    attrs: {
      "href": "https://github.com/misterGF/CoPilot",
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "fa fa-github fa-2x"
  })])])]), _vm._v(" "), _c('va-alert', {
    attrs: {
      "type": "danger"
    }
  }, [_c('h4', {
    slot: "header"
  }, [_c('i', {
    staticClass: "icon fa fa-check"
  }), _vm._v(" CoPilot is open source!\n        ")]), _vm._v(" "), _c('div', {
    slot: "body"
  }, [_vm._v("\n          Click on icon to check out it out on github.\n          "), _c('a', {
    attrs: {
      "href": "https://github.com/misterGF/CoPilot",
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "fa fa-github fa-2x"
  })])])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('alert', {
    attrs: {
      "dismissible": true
    }
  }, [_c('h4', {
    slot: "header"
  }, [_c('i', {
    staticClass: "icon fa fa-check"
  }), _vm._v(" CoPilot is open source!\n        ")]), _vm._v(" "), _c('div', {
    slot: "body"
  }, [_vm._v("\n          Click on icon to check out it out on github.\n          "), _c('a', {
    attrs: {
      "href": "https://github.com/misterGF/CoPilot",
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "fa fa-github fa-2x"
  })])])]), _vm._v(" "), _c('alert', {
    attrs: {
      "type": "success",
      "dismissible": true
    }
  }, [_c('h4', {
    slot: "header"
  }, [_c('i', {
    staticClass: "icon fa fa-check"
  }), _vm._v(" CoPilot is open source!\n        ")]), _vm._v(" "), _c('div', {
    slot: "body"
  }, [_vm._v("\n          Click on icon to check out it out on github.\n          "), _c('a', {
    attrs: {
      "href": "https://github.com/misterGF/CoPilot",
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "fa fa-github fa-2x"
  })])])]), _vm._v(" "), _c('alert', {
    attrs: {
      "type": "info",
      "dismissible": true
    }
  }, [_c('h4', {
    slot: "header"
  }, [_c('i', {
    staticClass: "icon fa fa-check"
  }), _vm._v(" CoPilot is open source!\n        ")]), _vm._v(" "), _c('div', {
    slot: "body"
  }, [_vm._v("\n          Click on icon to check out it out on github.\n          "), _c('a', {
    attrs: {
      "href": "https://github.com/misterGF/CoPilot",
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "fa fa-github fa-2x"
  })])])]), _vm._v(" "), _c('alert', {
    attrs: {
      "type": "warning",
      "dismissible": true
    }
  }, [_c('h4', {
    slot: "header"
  }, [_c('i', {
    staticClass: "icon fa fa-check"
  }), _vm._v(" CoPilot is open source!\n        ")]), _vm._v(" "), _c('div', {
    slot: "body"
  }, [_vm._v("\n          Click on icon to check out it out on github.\n          "), _c('a', {
    attrs: {
      "href": "https://github.com/misterGF/CoPilot",
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "fa fa-github fa-2x"
  })])])]), _vm._v(" "), _c('alert', {
    attrs: {
      "type": "danger",
      "dismissible": true
    }
  }, [_c('h4', {
    slot: "header"
  }, [_c('i', {
    staticClass: "icon fa fa-check"
  }), _vm._v(" CoPilot is open source!\n        ")]), _vm._v(" "), _c('div', {
    slot: "body"
  }, [_vm._v("\n          Click on icon to check out it out on github.\n          "), _c('a', {
    attrs: {
      "href": "https://github.com/misterGF/CoPilot",
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "fa fa-github fa-2x"
  })])])])], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header"
  }, [_c('h2', [_vm._v("Normal Alerts")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header"
  }, [_c('h2', [_vm._v("Dismissible Alerts")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-459d00a6!./~/vue-loader/lib/selector.js?type=template&index=0!./src/examples/AlertExample.vue
// module id = 510
// module chunks = 1